/** Matches main_vendor / Robot.vendor choices (see API migrations). */
export const VENDOR = {
  AUTONOMICS: 'AUTONOMICS',
  GAUSIUM: 'GAUSIUM',
} as const

export type VendorCode = typeof VENDOR[keyof typeof VENDOR]

const VENDOR_DISPLAY: Record<string, string> = {
  [VENDOR.AUTONOMICS]: 'Autonomics',
  [VENDOR.GAUSIUM]: 'Gausium',
}

/**
 * Human-readable vendor label for UI (filters, etc.). Falls back to a softened code if unknown.
 */
export function getVendorDisplayName(code: VendorCode | string): string {
  if (VENDOR_DISPLAY[code]) return VENDOR_DISPLAY[code]
  if (!code) return ''
  return code
    .split('_')
    .map(part => part.charAt(0) + part.slice(1).toLowerCase())
    .join(' ')
}
